import clsx from 'clsx'
import React from 'react'

type IconBgProps = {
  children: React.ReactNode
  className?: string
  size?: 'sm'
}

const IconBg = ({ children, className, size }: IconBgProps) => {
  return (
    <div
      className={clsx(
        'rounded-lg flex items-center justify-center',
        size === 'sm' ? 'w-11 h-11' : 'w-16 h-16',
        className
      )}
    >
      {children}
    </div>
  )
}

export default IconBg
